import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import styles from "./AnimatedMap.module.scss";
import { useGSAP } from "@gsap/react";

const AnimatedMap = () => {
  const dotsBoardRed = useRef();
  const blackDots = useRef();
  const greenDots = useRef();

  useGSAP(() => {
    gsap.from(blackDots.current.children, {
      x: 100, // move the items up
      y: 160,
      opacity: 0, // start with 0 opacity
      stagger: 0.0015, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      delay: 0.5,
      scrollTrigger: {
        trigger: blackDots.current,
        start: "top 50%",
        toggleActions: "play none none none", // only play the animation once
      },
    });
    gsap.from(greenDots.current.children, {
      y: -60,
      opacity: 0, // start with 0 opacity
      stagger: 0.15, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      delay: 2,
      scrollTrigger: {
        trigger: blackDots.current,
        start: "top 50%",
        toggleActions: "play none none none", // only play the animation once
      },
    });
  });

  useEffect(() => {
    const circles = dotsBoardRed.current.querySelectorAll("circle");

    circles.forEach((circle) => {
      // Add hover effect
      circle.addEventListener("mouseenter", () => {
        gsap.to(circle, { attr: { r: 16 }, duration: 0.5, ease: "power3.out" });
      });

      circle.addEventListener("mouseleave", () => {
        gsap.to(circle, { attr: { r: 8 }, duration: 0.5, ease: "power1.out" });
      });
    });

    return () => {
      // Cleanup event listeners
      circles.forEach((circle) => {
        circle.removeEventListener("mouseenter", null);
        circle.removeEventListener("mouseleave", null);
      });
    };
  }, []);
  return (
    <svg
      className={styles.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1000"
      ref={dotsBoardRed}
    >
      <g ref={blackDots}>
        <circle className={styles.black} cx="428" cy="92" r="8" />
        <circle className={styles.black} cx="456" cy="92" r="8" />
        <circle className={styles.black} cx="484" cy="92" r="8" />
        <circle className={styles.black} cx="512" cy="92" r="8" />
        <circle className={styles.black} cx="540" cy="92" r="8" />
        <circle className={styles.black} cx="568" cy="92" r="8" />
        <circle className={styles.black} cx="596" cy="92" r="8" />
        <circle className={styles.black} cx="624" cy="92" r="8" />
        <circle className={styles.black} cx="652" cy="92" r="8" />
        <circle className={styles.black} cx="680" cy="92" r="8" />
        <circle className={styles.black} cx="708" cy="92" r="8" />
        <circle className={styles.black} cx="736" cy="92" r="8" />
        <circle className={styles.black} cx="764" cy="92" r="8" />
        <circle className={styles.black} cx="372" cy="120" r="8" />
        <circle className={styles.black} cx="400" cy="120" r="8" />
        <circle className={styles.black} cx="428" cy="120" r="8" />
        <circle className={styles.black} cx="456" cy="120" r="8" />
        <circle className={styles.black} cx="484" cy="120" r="8" />
        <circle className={styles.black} cx="512" cy="120" r="8" />
        <circle className={styles.black} cx="540" cy="120" r="8" />
        <circle className={styles.black} cx="568" cy="120" r="8" />
        <circle className={styles.black} cx="596" cy="120" r="8" />
        <circle className={styles.black} cx="624" cy="120" r="8" />
        <circle className={styles.black} cx="652" cy="120" r="8" />
        <circle className={styles.black} cx="680" cy="120" r="8" />
        <circle className={styles.black} cx="708" cy="120" r="8" />
        <circle className={styles.black} cx="736" cy="120" r="8" />
        <circle className={styles.black} cx="764" cy="120" r="8" />
        <circle className={styles.black} cx="792" cy="120" r="8" />
        <circle className={styles.black} cx="988" cy="120" r="8" />
        <circle className={styles.black} cx="1016" cy="120" r="8" />
        <circle className={styles.black} cx="1128" cy="120" r="8" />
        <circle className={styles.black} cx="1156" cy="120" r="8" />
        <circle className={styles.black} cx="1184" cy="120" r="8" />
        <circle className={styles.black} cx="1212" cy="120" r="8" />
        <circle className={styles.black} cx="1408" cy="120" r="8" />
        <circle className={styles.black} cx="288" cy="148" r="8" />
        <circle className={styles.black} cx="316" cy="148" r="8" />
        <circle className={styles.black} cx="344" cy="148" r="8" />
        <circle className={styles.black} cx="400" cy="148" r="8" />
        <circle className={styles.black} cx="428" cy="148" r="8" />
        <circle className={styles.black} cx="456" cy="148" r="8" />
        <circle className={styles.black} cx="512" cy="148" r="8" />
        <circle className={styles.black} cx="540" cy="148" r="8" />
        <circle className={styles.black} cx="568" cy="148" r="8" />
        <circle className={styles.black} cx="596" cy="148" r="8" />
        <circle className={styles.black} cx="624" cy="148" r="8" />
        <circle className={styles.black} cx="652" cy="148" r="8" />
        <circle className={styles.black} cx="680" cy="148" r="8" />
        <circle className={styles.black} cx="708" cy="148" r="8" />
        <circle className={styles.black} cx="736" cy="148" r="8" />
        <circle className={styles.black} cx="764" cy="148" r="8" />
        <circle className={styles.black} cx="960" cy="148" r="8" />
        <circle className={styles.black} cx="988" cy="148" r="8" />
        <circle className={styles.black} cx="1016" cy="148" r="8" />
        <circle className={styles.black} cx="1436" cy="148" r="8" />
        <circle className={styles.black} cx="232" cy="176" r="8" />
        <circle className={styles.black} cx="260" cy="176" r="8" />
        <circle className={styles.black} cx="288" cy="176" r="8" />
        <circle className={styles.black} cx="316" cy="176" r="8" />
        <circle className={styles.black} cx="344" cy="176" r="8" />
        <circle className={styles.black} cx="372" cy="176" r="8" />
        <circle className={styles.black} cx="400" cy="176" r="8" />
        <circle className={styles.black} cx="512" cy="176" r="8" />
        <circle className={styles.black} cx="540" cy="176" r="8" />
        <circle className={styles.black} cx="568" cy="176" r="8" />
        <circle className={styles.black} cx="596" cy="176" r="8" />
        <circle className={styles.black} cx="624" cy="176" r="8" />
        <circle className={styles.black} cx="652" cy="176" r="8" />
        <circle className={styles.black} cx="680" cy="176" r="8" />
        <circle className={styles.black} cx="708" cy="176" r="8" />
        <circle className={styles.black} cx="736" cy="176" r="8" />
        <circle className={styles.black} cx="764" cy="176" r="8" />
        <circle className={styles.black} cx="1212" cy="176" r="8" />
        <circle className={styles.black} cx="1240" cy="176" r="8" />
        <circle className={styles.black} cx="1408" cy="176" r="8" />
        <circle className={styles.black} cx="1436" cy="176" r="8" />
        <circle className={styles.black} cx="1464" cy="176" r="8" />
        <circle className={styles.black} cx="1492" cy="176" r="8" />
        <circle className={styles.black} cx="1632" cy="176" r="8" />
        <circle className={styles.black} cx="1660" cy="176" r="8" />
        <circle className={styles.black} cx="204" cy="204" r="8" />
        <circle className={styles.black} cx="232" cy="204" r="8" />
        <circle className={styles.black} cx="260" cy="204" r="8" />
        <circle className={styles.black} cx="288" cy="204" r="8" />
        <circle className={styles.black} cx="316" cy="204" r="8" />
        <circle className={styles.black} cx="344" cy="204" r="8" />
        <circle className={styles.black} cx="372" cy="204" r="8" />
        <circle className={styles.black} cx="400" cy="204" r="8" />
        <circle className={styles.black} cx="428" cy="204" r="8" />
        <circle className={styles.black} cx="456" cy="204" r="8" />
        <circle className={styles.black} cx="596" cy="204" r="8" />
        <circle className={styles.black} cx="624" cy="204" r="8" />
        <circle className={styles.black} cx="652" cy="204" r="8" />
        <circle className={styles.black} cx="680" cy="204" r="8" />
        <circle className={styles.black} cx="708" cy="204" r="8" />
        <circle className={styles.black} cx="736" cy="204" r="8" />
        <circle className={styles.black} cx="764" cy="204" r="8" />
        <circle className={styles.black} cx="1184" cy="204" r="8" />
        <circle className={styles.black} cx="1268" cy="204" r="8" />
        <circle className={styles.black} cx="1324" cy="204" r="8" />
        <circle className={styles.black} cx="1352" cy="204" r="8" />
        <circle className={styles.black} cx="1380" cy="204" r="8" />
        <circle className={styles.black} cx="1408" cy="204" r="8" />
        <circle className={styles.black} cx="1436" cy="204" r="8" />
        <circle className={styles.black} cx="1464" cy="204" r="8" />
        <circle className={styles.black} cx="1492" cy="204" r="8" />
        <circle className={styles.black} cx="1520" cy="204" r="8" />
        <circle className={styles.black} cx="1548" cy="204" r="8" />
        <circle className={styles.black} cx="1576" cy="204" r="8" />
        <circle className={styles.black} cx="1660" cy="204" r="8" />
        <circle className={styles.black} cx="64" cy="232" r="8" />
        <circle className={styles.black} cx="260" cy="232" r="8" />
        <circle className={styles.black} cx="288" cy="232" r="8" />
        <circle className={styles.black} cx="316" cy="232" r="8" />
        <circle className={styles.black} cx="372" cy="232" r="8" />
        <circle className={styles.black} cx="400" cy="232" r="8" />
        <circle className={styles.black} cx="428" cy="232" r="8" />
        <circle className={styles.black} cx="456" cy="232" r="8" />
        <circle className={styles.black} cx="484" cy="232" r="8" />
        <circle className={styles.black} cx="512" cy="232" r="8" />
        <circle className={styles.black} cx="596" cy="232" r="8" />
        <circle className={styles.black} cx="624" cy="232" r="8" />
        <circle className={styles.black} cx="652" cy="232" r="8" />
        <circle className={styles.black} cx="680" cy="232" r="8" />
        <circle className={styles.black} cx="708" cy="232" r="8" />
        <circle className={styles.black} cx="736" cy="232" r="8" />
        <circle className={styles.black} cx="764" cy="232" r="8" />
        <circle className={styles.black} cx="988" cy="232" r="8" />
        <circle className={styles.black} cx="1016" cy="232" r="8" />
        <circle className={styles.black} cx="1044" cy="232" r="8" />
        <circle className={styles.black} cx="1184" cy="232" r="8" />
        <circle className={styles.black} cx="1212" cy="232" r="8" />
        <circle className={styles.black} cx="1268" cy="232" r="8" />
        <circle className={styles.black} cx="1296" cy="232" r="8" />
        <circle className={styles.black} cx="1324" cy="232" r="8" />
        <circle className={styles.black} cx="1352" cy="232" r="8" />
        <circle className={styles.black} cx="1380" cy="232" r="8" />
        <circle className={styles.black} cx="1408" cy="232" r="8" />
        <circle className={styles.black} cx="1436" cy="232" r="8" />
        <circle className={styles.black} cx="1464" cy="232" r="8" />
        <circle className={styles.black} cx="1492" cy="232" r="8" />
        <circle className={styles.black} cx="1520" cy="232" r="8" />
        <circle className={styles.black} cx="1548" cy="232" r="8" />
        <circle className={styles.black} cx="1576" cy="232" r="8" />
        <circle className={styles.black} cx="1604" cy="232" r="8" />
        <circle className={styles.black} cx="1632" cy="232" r="8" />
        <circle className={styles.black} cx="1660" cy="232" r="8" />
        <circle className={styles.black} cx="1688" cy="232" r="8" />
        <circle className={styles.black} cx="1716" cy="232" r="8" />
        <circle className={styles.black} cx="1744" cy="232" r="8" />
        <circle className={styles.black} cx="1856" cy="232" r="8" />
        <circle className={styles.black} cx="64" cy="260" r="8" />
        <circle className={styles.black} cx="92" cy="260" r="8" />
        <circle className={styles.black} cx="120" cy="260" r="8" />
        <circle className={styles.black} cx="148" cy="260" r="8" />
        <circle className={styles.black} cx="176" cy="260" r="8" />
        <circle className={styles.black} cx="204" cy="260" r="8" />
        <circle className={styles.black} cx="232" cy="260" r="8" />
        <circle className={styles.black} cx="260" cy="260" r="8" />
        <circle className={styles.black} cx="288" cy="260" r="8" />
        <circle className={styles.black} cx="316" cy="260" r="8" />
        <circle className={styles.black} cx="344" cy="260" r="8" />
        <circle className={styles.black} cx="372" cy="260" r="8" />
        <circle className={styles.black} cx="400" cy="260" r="8" />
        <circle className={styles.black} cx="428" cy="260" r="8" />
        <circle className={styles.black} cx="484" cy="260" r="8" />
        <circle className={styles.black} cx="512" cy="260" r="8" />
        <circle className={styles.black} cx="540" cy="260" r="8" />
        <circle className={styles.black} cx="596" cy="260" r="8" />
        <circle className={styles.black} cx="624" cy="260" r="8" />
        <circle className={styles.black} cx="652" cy="260" r="8" />
        <circle className={styles.black} cx="680" cy="260" r="8" />
        <circle className={styles.black} cx="708" cy="260" r="8" />
        <circle className={styles.black} cx="960" cy="260" r="8" />
        <circle className={styles.black} cx="988" cy="260" r="8" />
        <circle className={styles.black} cx="1016" cy="260" r="8" />
        <circle className={styles.black} cx="1044" cy="260" r="8" />
        <circle className={styles.black} cx="1072" cy="260" r="8" />
        <circle className={styles.black} cx="1100" cy="260" r="8" />
        <circle className={styles.black} cx="1128" cy="260" r="8" />
        <circle className={styles.black} cx="1156" cy="260" r="8" />
        <circle className={styles.black} cx="1184" cy="260" r="8" />
        <circle className={styles.black} cx="1212" cy="260" r="8" />
        <circle className={styles.black} cx="1240" cy="260" r="8" />
        <circle className={styles.black} cx="1268" cy="260" r="8" />
        <circle className={styles.black} cx="1296" cy="260" r="8" />
        <circle className={styles.black} cx="1324" cy="260" r="8" />
        <circle className={styles.black} cx="1352" cy="260" r="8" />
        <circle className={styles.black} cx="1380" cy="260" r="8" />
        <circle className={styles.black} cx="1408" cy="260" r="8" />
        <circle className={styles.black} cx="1436" cy="260" r="8" />
        <circle className={styles.black} cx="1464" cy="260" r="8" />
        <circle className={styles.black} cx="1492" cy="260" r="8" />
        <circle className={styles.black} cx="1520" cy="260" r="8" />
        <circle className={styles.black} cx="1548" cy="260" r="8" />
        <circle className={styles.black} cx="1576" cy="260" r="8" />
        <circle className={styles.black} cx="1604" cy="260" r="8" />
        <circle className={styles.black} cx="1632" cy="260" r="8" />
        <circle className={styles.black} cx="1660" cy="260" r="8" />
        <circle className={styles.black} cx="1688" cy="260" r="8" />
        <circle className={styles.black} cx="1716" cy="260" r="8" />
        <circle className={styles.black} cx="1744" cy="260" r="8" />
        <circle className={styles.black} cx="1772" cy="260" r="8" />
        <circle className={styles.black} cx="1800" cy="260" r="8" />
        <circle className={styles.black} cx="1828" cy="260" r="8" />
        <circle className={styles.black} cx="1856" cy="260" r="8" />
        <circle className={styles.black} cx="64" cy="288" r="8" />
        <circle className={styles.black} cx="92" cy="288" r="8" />
        <circle className={styles.black} cx="120" cy="288" r="8" />
        <circle className={styles.black} cx="148" cy="288" r="8" />
        <circle className={styles.black} cx="176" cy="288" r="8" />
        <circle className={styles.black} cx="204" cy="288" r="8" />
        <circle className={styles.black} cx="232" cy="288" r="8" />
        <circle className={styles.black} cx="260" cy="288" r="8" />
        <circle className={styles.black} cx="288" cy="288" r="8" />
        <circle className={styles.black} cx="316" cy="288" r="8" />
        <circle className={styles.black} cx="344" cy="288" r="8" />
        <circle className={styles.black} cx="372" cy="288" r="8" />
        <circle className={styles.black} cx="400" cy="288" r="8" />
        <circle className={styles.black} cx="428" cy="288" r="8" />
        <circle className={styles.black} cx="456" cy="288" r="8" />
        <circle className={styles.black} cx="484" cy="288" r="8" />
        <circle className={styles.black} cx="512" cy="288" r="8" />
        <circle className={styles.black} cx="596" cy="288" r="8" />
        <circle className={styles.black} cx="624" cy="288" r="8" />
        <circle className={styles.black} cx="652" cy="288" r="8" />
        <circle className={styles.black} cx="764" cy="288" r="8" />
        <circle className={styles.black} cx="792" cy="288" r="8" />
        <circle className={styles.black} cx="960" cy="288" r="8" />
        <circle className={styles.black} cx="1044" cy="288" r="8" />
        <circle className={styles.black} cx="1072" cy="288" r="8" />
        <circle className={styles.black} cx="1100" cy="288" r="8" />
        <circle className={styles.black} cx="1128" cy="288" r="8" />
        <circle className={styles.black} cx="1156" cy="288" r="8" />
        <circle className={styles.black} cx="1184" cy="288" r="8" />
        <circle className={styles.black} cx="1212" cy="288" r="8" />
        <circle className={styles.black} cx="1240" cy="288" r="8" />
        <circle className={styles.black} cx="1268" cy="288" r="8" />
        <circle className={styles.black} cx="1296" cy="288" r="8" />
        <circle className={styles.black} cx="1324" cy="288" r="8" />
        <circle className={styles.black} cx="1352" cy="288" r="8" />
        <circle className={styles.black} cx="1380" cy="288" r="8" />
        <circle className={styles.black} cx="1408" cy="288" r="8" />
        <circle className={styles.black} cx="1436" cy="288" r="8" />
        <circle className={styles.black} cx="1464" cy="288" r="8" />
        <circle className={styles.black} cx="1492" cy="288" r="8" />
        <circle className={styles.black} cx="1520" cy="288" r="8" />
        <circle className={styles.black} cx="1548" cy="288" r="8" />
        <circle className={styles.black} cx="1576" cy="288" r="8" />
        <circle className={styles.black} cx="1604" cy="288" r="8" />
        <circle className={styles.black} cx="1632" cy="288" r="8" />
        <circle className={styles.black} cx="1660" cy="288" r="8" />
        <circle className={styles.black} cx="1688" cy="288" r="8" />
        <circle className={styles.black} cx="1716" cy="288" r="8" />
        <circle className={styles.black} cx="1744" cy="288" r="8" />
        <circle className={styles.black} cx="1772" cy="288" r="8" />
        <circle className={styles.black} cx="1800" cy="288" r="8" />
        <circle className={styles.black} cx="1828" cy="288" r="8" />
        <circle className={styles.black} cx="1856" cy="288" r="8" />
        <circle className={styles.black} cx="64" cy="316" r="8" />
        <circle className={styles.black} cx="92" cy="316" r="8" />
        <circle className={styles.black} cx="120" cy="316" r="8" />
        <circle className={styles.black} cx="148" cy="316" r="8" />
        <circle className={styles.black} cx="176" cy="316" r="8" />
        <circle className={styles.black} cx="204" cy="316" r="8" />
        <circle className={styles.black} cx="232" cy="316" r="8" />
        <circle className={styles.black} cx="260" cy="316" r="8" />
        <circle className={styles.black} cx="288" cy="316" r="8" />
        <circle className={styles.black} cx="316" cy="316" r="8" />
        <circle className={styles.black} cx="344" cy="316" r="8" />
        <circle className={styles.black} cx="372" cy="316" r="8" />
        <circle className={styles.black} cx="456" cy="316" r="8" />
        <circle className={styles.black} cx="484" cy="316" r="8" />
        <circle className={styles.black} cx="624" cy="316" r="8" />
        <circle className={styles.black} cx="652" cy="316" r="8" />
        <circle
          className={styles.black}
          cx="876"
          cy="316"
          r="8"
          id="scotland"
        />
        <circle className={styles.black} cx="932" cy="316" r="8" />
        <circle className={styles.black} cx="960" cy="316" r="8" />
        <circle className={styles.black} cx="1016" cy="316" r="8" />
        <circle className={styles.black} cx="1044" cy="316" r="8" />
        <circle className={styles.black} cx="1072" cy="316" r="8" />
        <circle className={styles.black} cx="1100" cy="316" r="8" />
        <circle className={styles.black} cx="1128" cy="316" r="8" />
        <circle className={styles.black} cx="1156" cy="316" r="8" />
        <circle className={styles.black} cx="1184" cy="316" r="8" />
        <circle className={styles.black} cx="1212" cy="316" r="8" />
        <circle className={styles.black} cx="1240" cy="316" r="8" />
        <circle className={styles.black} cx="1268" cy="316" r="8" />
        <circle className={styles.black} cx="1296" cy="316" r="8" />
        <circle className={styles.black} cx="1324" cy="316" r="8" />
        <circle className={styles.black} cx="1352" cy="316" r="8" />
        <circle className={styles.black} cx="1380" cy="316" r="8" />
        <circle className={styles.black} cx="1408" cy="316" r="8" />
        <circle className={styles.black} cx="1436" cy="316" r="8" />
        <circle className={styles.black} cx="1464" cy="316" r="8" />
        <circle className={styles.black} cx="1492" cy="316" r="8" />
        <circle className={styles.black} cx="1520" cy="316" r="8" />
        <circle className={styles.black} cx="1548" cy="316" r="8" />
        <circle className={styles.black} cx="1576" cy="316" r="8" />
        <circle className={styles.black} cx="1604" cy="316" r="8" />
        <circle className={styles.black} cx="1632" cy="316" r="8" />
        <circle className={styles.black} cx="1660" cy="316" r="8" />
        <circle className={styles.black} cx="1688" cy="316" r="8" />
        <circle className={styles.black} cx="1716" cy="316" r="8" />
        <circle className={styles.black} cx="1744" cy="316" r="8" />
        <circle className={styles.black} cx="1772" cy="316" r="8" />
        <circle className={styles.black} cx="1800" cy="316" r="8" />
        <circle className={styles.black} cx="1828" cy="316" r="8" />
        <circle className={styles.black} cx="148" cy="344" r="8" />
        <circle className={styles.black} cx="176" cy="344" r="8" />
        <circle className={styles.black} cx="204" cy="344" r="8" />
        <circle className={styles.black} cx="232" cy="344" r="8" />
        <circle className={styles.black} cx="260" cy="344" r="8" />
        <circle className={styles.black} cx="288" cy="344" r="8" />
        <circle className={styles.black} cx="316" cy="344" r="8" />
        <circle className={styles.black} cx="344" cy="344" r="8" />
        <circle className={styles.black} cx="372" cy="344" r="8" />
        <circle className={styles.black} cx="456" cy="344" r="8" />
        <circle className={styles.black} cx="484" cy="344" r="8" />
        <circle className={styles.black} cx="512" cy="344" r="8" />
        <circle className={styles.black} cx="540" cy="344" r="8" />
        <circle className={styles.black} cx="848" cy="344" r="8" />
        <circle className={styles.black} cx="876" cy="344" r="8" />
        <circle className={styles.black} cx="932" cy="344" r="8" />
        <circle className={styles.black} cx="960" cy="344" r="8" />
        <circle className={styles.black} cx="988" cy="344" r="8" />
        <circle className={styles.black} cx="1016" cy="344" r="8" />
        <circle className={styles.black} cx="1044" cy="344" r="8" />
        <circle className={styles.black} cx="1072" cy="344" r="8" />
        <circle className={styles.black} cx="1100" cy="344" r="8" />
        <circle className={styles.black} cx="1128" cy="344" r="8" />
        <circle className={styles.black} cx="1156" cy="344" r="8" />
        <circle className={styles.black} cx="1184" cy="344" r="8" />
        <circle className={styles.black} cx="1212" cy="344" r="8" />
        <circle className={styles.black} cx="1240" cy="344" r="8" />
        <circle className={styles.black} cx="1268" cy="344" r="8" />
        <circle className={styles.black} cx="1296" cy="344" r="8" />
        <circle className={styles.black} cx="1324" cy="344" r="8" />
        <circle className={styles.black} cx="1352" cy="344" r="8" />
        <circle className={styles.black} cx="1380" cy="344" r="8" />
        <circle className={styles.black} cx="1408" cy="344" r="8" />
        <circle className={styles.black} cx="1436" cy="344" r="8" />
        <circle className={styles.black} cx="1464" cy="344" r="8" />
        <circle className={styles.black} cx="1492" cy="344" r="8" />
        <circle className={styles.black} cx="1520" cy="344" r="8" />
        <circle className={styles.black} cx="1548" cy="344" r="8" />
        <circle className={styles.black} cx="1576" cy="344" r="8" />
        <circle className={styles.black} cx="1604" cy="344" r="8" />
        <circle className={styles.black} cx="1632" cy="344" r="8" />
        <circle className={styles.black} cx="1744" cy="344" r="8" />
        <circle className={styles.black} cx="176" cy="372" r="8" />
        <circle className={styles.black} cx="204" cy="372" r="8" />
        <circle className={styles.black} cx="232" cy="372" r="8" />
        <circle className={styles.black} cx="260" cy="372" r="8" />
        <circle className={styles.black} cx="288" cy="372" r="8" />
        <circle className={styles.black} cx="316" cy="372" r="8" />
        <circle className={styles.black} cx="344" cy="372" r="8" />
        <circle className={styles.black} cx="372" cy="372" r="8" />
        <circle className={styles.black} cx="400" cy="372" r="8" />
        <circle className={styles.black} cx="428" cy="372" r="8" />
        <circle className={styles.black} cx="456" cy="372" r="8" />
        <circle className={styles.black} cx="484" cy="372" r="8" />
        <circle className={styles.black} cx="512" cy="372" r="8" />
        <circle className={styles.black} cx="540" cy="372" r="8" />
        <circle className={styles.black} cx="568" cy="372" r="8" />
        <circle className={styles.black} cx="848" cy="372" r="8" />
        <circle className={styles.black} cx="960" cy="372" r="8" />
        <circle className={styles.black} cx="988" cy="372" r="8" />
        <circle className={styles.black} cx="1016" cy="372" r="8" />
        <circle className={styles.black} cx="1044" cy="372" r="8" />
        <circle className={styles.black} cx="1072" cy="372" r="8" />
        <circle className={styles.black} cx="1100" cy="372" r="8" />
        <circle className={styles.black} cx="1128" cy="372" r="8" />
        <circle className={styles.black} cx="1156" cy="372" r="8" />
        <circle className={styles.black} cx="1184" cy="372" r="8" />
        <circle className={styles.black} cx="1212" cy="372" r="8" />
        <circle className={styles.black} cx="1240" cy="372" r="8" />
        <circle className={styles.black} cx="1268" cy="372" r="8" />
        <circle className={styles.black} cx="1296" cy="372" r="8" />
        <circle className={styles.black} cx="1324" cy="372" r="8" />
        <circle className={styles.black} cx="1352" cy="372" r="8" />
        <circle className={styles.black} cx="1380" cy="372" r="8" />
        <circle className={styles.black} cx="1408" cy="372" r="8" />
        <circle className={styles.black} cx="1436" cy="372" r="8" />
        <circle className={styles.black} cx="1464" cy="372" r="8" />
        <circle className={styles.black} cx="1492" cy="372" r="8" />
        <circle className={styles.black} cx="1520" cy="372" r="8" />
        <circle className={styles.black} cx="1548" cy="372" r="8" />
        <circle className={styles.black} cx="1576" cy="372" r="8" />
        <circle className={styles.black} cx="1604" cy="372" r="8" />
        <circle className={styles.black} cx="1744" cy="372" r="8" />
        <circle className={styles.black} cx="204" cy="400" r="8" />
        <circle className={styles.black} cx="232" cy="400" r="8" />
        <circle className={styles.black} cx="260" cy="400" r="8" />
        <circle className={styles.black} cx="288" cy="400" r="8" />
        <circle className={styles.black} cx="316" cy="400" r="8" />
        <circle className={styles.black} cx="344" cy="400" r="8" />
        <circle className={styles.black} cx="372" cy="400" r="8" />
        <circle className={styles.black} cx="400" cy="400" r="8" />
        <circle className={styles.black} cx="428" cy="400" r="8" />
        <circle className={styles.black} cx="456" cy="400" r="8" />
        <circle className={styles.black} cx="484" cy="400" r="8" />
        <circle className={styles.black} cx="512" cy="400" r="8" />
        <circle className={styles.black} cx="540" cy="400" r="8" />
        <circle className={styles.black} cx="568" cy="400" r="8" />
        <circle className={styles.black} cx="960" cy="400" r="8" />
        <circle className={styles.black} cx="988" cy="400" r="8" />
        <circle className={styles.black} cx="1016" cy="400" r="8" />
        <circle className={styles.black} cx="1044" cy="400" r="8" />
        <circle className={styles.black} cx="1072" cy="400" r="8" />
        <circle className={styles.black} cx="1100" cy="400" r="8" />
        <circle className={styles.black} cx="1128" cy="400" r="8" />
        <circle className={styles.black} cx="1156" cy="400" r="8" />
        <circle className={styles.black} cx="1184" cy="400" r="8" />
        <circle className={styles.black} cx="1212" cy="400" r="8" />
        <circle className={styles.black} cx="1240" cy="400" r="8" />
        <circle className={styles.black} cx="1268" cy="400" r="8" />
        <circle className={styles.black} cx="1296" cy="400" r="8" />
        <circle className={styles.black} cx="1324" cy="400" r="8" />
        <circle className={styles.black} cx="1352" cy="400" r="8" />
        <circle className={styles.black} cx="1380" cy="400" r="8" />
        <circle className={styles.black} cx="1408" cy="400" r="8" />
        <circle className={styles.black} cx="1436" cy="400" r="8" />
        <circle className={styles.black} cx="1464" cy="400" r="8" />
        <circle className={styles.black} cx="1492" cy="400" r="8" />
        <circle className={styles.black} cx="1520" cy="400" r="8" />
        <circle className={styles.black} cx="1548" cy="400" r="8" />
        <circle className={styles.black} cx="1576" cy="400" r="8" />
        <circle className={styles.black} cx="1604" cy="400" r="8" />
        <circle className={styles.black} cx="1632" cy="400" r="8" />
        <circle className={styles.black} cx="1660" cy="400" r="8" />
        <circle className={styles.black} cx="1744" cy="400" r="8" />
        <circle className={styles.black} cx="232" cy="428" r="8" />
        <circle className={styles.black} cx="260" cy="428" r="8" />
        <circle className={styles.black} cx="288" cy="428" r="8" />
        <circle className={styles.black} cx="316" cy="428" r="8" />
        <circle className={styles.black} cx="344" cy="428" r="8" />
        <circle className={styles.black} cx="372" cy="428" r="8" />
        <circle className={styles.black} cx="400" cy="428" r="8" />
        <circle className={styles.black} cx="456" cy="428" r="8" />
        <circle className={styles.black} cx="484" cy="428" r="8" />
        <circle className={styles.black} cx="512" cy="428" r="8" />
        <circle className={styles.black} cx="596" cy="428" r="8" />
        <circle className={styles.black} cx="876" cy="428" r="8" />
        <circle className={styles.black} cx="904" cy="428" r="8" />
        <circle className={styles.black} cx="932" cy="428" r="8" />
        <circle className={styles.black} cx="960" cy="428" r="8" />
        <circle className={styles.black} cx="1016" cy="428" r="8" />
        <circle className={styles.black} cx="1044" cy="428" r="8" />
        <circle className={styles.black} cx="1072" cy="428" r="8" />
        <circle className={styles.black} cx="1100" cy="428" r="8" />
        <circle className={styles.black} cx="1128" cy="428" r="8" />
        <circle className={styles.black} cx="1156" cy="428" r="8" />
        <circle className={styles.black} cx="1184" cy="428" r="8" />
        <circle className={styles.black} cx="1212" cy="428" r="8" />
        <circle className={styles.black} cx="1240" cy="428" r="8" />
        <circle className={styles.black} cx="1268" cy="428" r="8" />
        <circle className={styles.black} cx="1296" cy="428" r="8" />
        <circle className={styles.black} cx="1324" cy="428" r="8" />
        <circle className={styles.black} cx="1352" cy="428" r="8" />
        <circle className={styles.black} cx="1380" cy="428" r="8" />
        <circle className={styles.black} cx="1408" cy="428" r="8" />
        <circle className={styles.black} cx="1436" cy="428" r="8" />
        <circle className={styles.black} cx="1464" cy="428" r="8" />
        <circle className={styles.black} cx="1492" cy="428" r="8" />
        <circle className={styles.black} cx="1520" cy="428" r="8" />
        <circle className={styles.black} cx="1548" cy="428" r="8" />
        <circle className={styles.black} cx="1576" cy="428" r="8" />
        <circle className={styles.black} cx="1604" cy="428" r="8" />
        <circle className={styles.black} cx="1632" cy="428" r="8" />
        <circle className={styles.black} cx="1660" cy="428" r="8" />
        <circle className={styles.black} cx="204" cy="456" r="8" />
        <circle className={styles.black} cx="232" cy="456" r="8" />
        <circle className={styles.black} cx="260" cy="456" r="8" />
        <circle className={styles.black} cx="288" cy="456" r="8" />
        <circle className={styles.black} cx="316" cy="456" r="8" />
        <circle className={styles.black} cx="344" cy="456" r="8" />
        <circle className={styles.black} cx="372" cy="456" r="8" />
        <circle className={styles.black} cx="400" cy="456" r="8" />
        <circle className={styles.black} cx="428" cy="456" r="8" />
        <circle className={styles.black} cx="456" cy="456" r="8" />
        <circle className={styles.black} cx="848" cy="456" r="8" />
        <circle className={styles.black} cx="876" cy="456" r="8" />
        <circle className={styles.black} cx="960" cy="456" r="8" />
        <circle className={styles.black} cx="988" cy="456" r="8" />
        <circle className={styles.black} cx="1016" cy="456" r="8" />
        <circle className={styles.black} cx="1128" cy="456" r="8" />
        <circle className={styles.black} cx="1184" cy="456" r="8" />
        <circle className={styles.black} cx="1212" cy="456" r="8" />
        <circle className={styles.black} cx="1240" cy="456" r="8" />
        <circle className={styles.black} cx="1268" cy="456" r="8" />
        <circle className={styles.black} cx="1296" cy="456" r="8" />
        <circle className={styles.black} cx="1324" cy="456" r="8" />
        <circle className={styles.black} cx="1352" cy="456" r="8" />
        <circle className={styles.black} cx="1380" cy="456" r="8" />
        <circle className={styles.black} cx="1408" cy="456" r="8" />
        <circle className={styles.black} cx="1436" cy="456" r="8" />
        <circle className={styles.black} cx="1464" cy="456" r="8" />
        <circle className={styles.black} cx="1492" cy="456" r="8" />
        <circle className={styles.black} cx="1520" cy="456" r="8" />
        <circle className={styles.black} cx="1548" cy="456" r="8" />
        <circle className={styles.black} cx="1576" cy="456" r="8" />
        <circle className={styles.black} cx="1604" cy="456" r="8" />
        <circle className={styles.black} cx="1660" cy="456" r="8" />
        <circle className={styles.black} cx="232" cy="484" r="8" />
        <circle className={styles.black} cx="260" cy="484" r="8" />
        <circle className={styles.black} cx="288" cy="484" r="8" />
        <circle className={styles.black} cx="316" cy="484" r="8" />
        <circle className={styles.black} cx="344" cy="484" r="8" />
        <circle className={styles.black} cx="372" cy="484" r="8" />
        <circle className={styles.black} cx="400" cy="484" r="8" />
        <circle className={styles.black} cx="428" cy="484" r="8" />
        <circle className={styles.black} cx="848" cy="484" r="8" />
        <circle className={styles.black} cx="904" cy="484" r="8" />
        <circle className={styles.black} cx="932" cy="484" r="8" />
        <circle className={styles.black} cx="1016" cy="484" r="8" />
        <circle className={styles.black} cx="1044" cy="484" r="8" />
        <circle className={styles.black} cx="1072" cy="484" r="8" />
        <circle className={styles.black} cx="1100" cy="484" r="8" />
        <circle className={styles.black} cx="1128" cy="484" r="8" />
        <circle className={styles.black} cx="1184" cy="484" r="8" />
        <circle className={styles.black} cx="1212" cy="484" r="8" />
        <circle className={styles.black} cx="1240" cy="484" r="8" />
        <circle className={styles.black} cx="1268" cy="484" r="8" />
        <circle className={styles.black} cx="1296" cy="484" r="8" />
        <circle className={styles.black} cx="1324" cy="484" r="8" />
        <circle className={styles.black} cx="1352" cy="484" r="8" />
        <circle className={styles.black} cx="1380" cy="484" r="8" />
        <circle className={styles.black} cx="1408" cy="484" r="8" />
        <circle className={styles.black} cx="1436" cy="484" r="8" />
        <circle className={styles.black} cx="1464" cy="484" r="8" />
        <circle className={styles.black} cx="1492" cy="484" r="8" />
        <circle className={styles.black} cx="1520" cy="484" r="8" />
        <circle className={styles.black} cx="1548" cy="484" r="8" />
        <circle className={styles.black} cx="1576" cy="484" r="8" />
        <circle className={styles.black} cx="1660" cy="484" r="8" />
        <circle className={styles.black} cx="232" cy="512" r="8" />
        <circle className={styles.black} cx="260" cy="512" r="8" />
        <circle className={styles.black} cx="288" cy="512" r="8" />
        <circle className={styles.black} cx="316" cy="512" r="8" />
        <circle className={styles.black} cx="344" cy="512" r="8" />
        <circle className={styles.black} cx="372" cy="512" r="8" />
        <circle className={styles.black} cx="400" cy="512" r="8" />
        <circle className={styles.black} cx="428" cy="512" r="8" />
        <circle className={styles.black} cx="456" cy="512" r="8" />
        <circle className={styles.black} cx="876" cy="512" r="8" />
        <circle className={styles.black} cx="904" cy="512" r="8" />
        <circle className={styles.black} cx="932" cy="512" r="8" />
        <circle className={styles.black} cx="1016" cy="512" r="8" />
        <circle className={styles.black} cx="1100" cy="512" r="8" />
        <circle className={styles.black} cx="1128" cy="512" r="8" />
        <circle className={styles.black} cx="1156" cy="512" r="8" />
        <circle className={styles.black} cx="1184" cy="512" r="8" />
        <circle className={styles.black} cx="1240" cy="512" r="8" />
        <circle className={styles.black} cx="1268" cy="512" r="8" />
        <circle className={styles.black} cx="1296" cy="512" r="8" />
        <circle className={styles.black} cx="1324" cy="512" r="8" />
        <circle className={styles.black} cx="1352" cy="512" r="8" />
        <circle className={styles.black} cx="1380" cy="512" r="8" />
        <circle className={styles.black} cx="1408" cy="512" r="8" />
        <circle className={styles.black} cx="1436" cy="512" r="8" />
        <circle className={styles.black} cx="1464" cy="512" r="8" />
        <circle className={styles.black} cx="1492" cy="512" r="8" />
        <circle className={styles.black} cx="1520" cy="512" r="8" />
        <circle className={styles.black} cx="1576" cy="512" r="8" />
        <circle className={styles.black} cx="1604" cy="512" r="8" />
        <circle className={styles.black} cx="1632" cy="512" r="8" />
        <circle className={styles.black} cx="260" cy="540" r="8" />
        <circle className={styles.black} cx="288" cy="540" r="8" />
        <circle className={styles.black} cx="316" cy="540" r="8" />
        <circle className={styles.black} cx="344" cy="540" r="8" />
        <circle className={styles.black} cx="372" cy="540" r="8" />
        <circle className={styles.black} cx="400" cy="540" r="8" />
        <circle className={styles.black} cx="428" cy="540" r="8" />
        <circle className={styles.black} cx="848" cy="540" r="8" />
        <circle className={styles.black} cx="876" cy="540" r="8" />
        <circle className={styles.black} cx="904" cy="540" r="8" />
        <circle className={styles.black} cx="932" cy="540" r="8" />
        <circle className={styles.black} cx="960" cy="540" r="8" />
        <circle className={styles.black} cx="988" cy="540" r="8" />
        <circle className={styles.black} cx="1016" cy="540" r="8" />
        <circle className={styles.black} cx="1044" cy="540" r="8" />
        <circle className={styles.black} cx="1072" cy="540" r="8" />
        <circle className={styles.black} cx="1100" cy="540" r="8" />
        <circle className={styles.black} cx="1128" cy="540" r="8" />
        <circle className={styles.black} cx="1156" cy="540" r="8" />
        <circle className={styles.black} cx="1212" cy="540" r="8" />
        <circle className={styles.black} cx="1240" cy="540" r="8" />
        <circle className={styles.black} cx="1268" cy="540" r="8" />
        <circle className={styles.black} cx="1296" cy="540" r="8" />
        <circle className={styles.black} cx="1324" cy="540" r="8" />
        <circle className={styles.black} cx="1352" cy="540" r="8" />
        <circle className={styles.black} cx="1380" cy="540" r="8" />
        <circle className={styles.black} cx="1408" cy="540" r="8" />
        <circle className={styles.black} cx="1436" cy="540" r="8" />
        <circle className={styles.black} cx="1464" cy="540" r="8" />
        <circle className={styles.black} cx="1492" cy="540" r="8" />
        <circle className={styles.black} cx="1520" cy="540" r="8" />
        <circle className={styles.black} cx="1548" cy="540" r="8" />
        <circle className={styles.black} cx="288" cy="568" r="8" />
        <circle className={styles.black} cx="316" cy="568" r="8" />
        <circle className={styles.black} cx="344" cy="568" r="8" />
        <circle className={styles.black} cx="456" cy="568" r="8" />
        <circle className={styles.black} cx="820" cy="568" r="8" />
        <circle className={styles.black} cx="848" cy="568" r="8" />
        <circle className={styles.black} cx="876" cy="568" r="8" />
        <circle className={styles.black} cx="904" cy="568" r="8" />
        <circle className={styles.black} cx="932" cy="568" r="8" />
        <circle className={styles.black} cx="960" cy="568" r="8" />
        <circle className={styles.black} cx="988" cy="568" r="8" />
        <circle className={styles.black} cx="1016" cy="568" r="8" />
        <circle className={styles.black} cx="1044" cy="568" r="8" />
        <circle className={styles.black} cx="1072" cy="568" r="8" />
        <circle className={styles.black} cx="1100" cy="568" r="8" />
        <circle className={styles.black} cx="1128" cy="568" r="8" />
        <circle className={styles.black} cx="1156" cy="568" r="8" />
        <circle className={styles.black} cx="1184" cy="568" r="8" />
        <circle className={styles.black} cx="1212" cy="568" r="8" />
        <circle className={styles.black} cx="1240" cy="568" r="8" />
        <circle className={styles.black} cx="1268" cy="568" r="8" />
        <circle className={styles.black} cx="1296" cy="568" r="8" />
        <circle className={styles.black} cx="1324" cy="568" r="8" />
        <circle className={styles.black} cx="1352" cy="568" r="8" />
        <circle className={styles.black} cx="1380" cy="568" r="8" />
        <circle className={styles.black} cx="1408" cy="568" r="8" />
        <circle className={styles.black} cx="1436" cy="568" r="8" />
        <circle className={styles.black} cx="1464" cy="568" r="8" />

        <circle className={styles.black} cx="1520" cy="568" r="8" />
        <circle className={styles.black} cx="1548" cy="568" r="8" />
        <circle className={styles.black} cx="316" cy="596" r="8" />
        <circle className={styles.black} cx="344" cy="596" r="8" />
        <circle className={styles.black} cx="400" cy="596" r="8" />
        <circle className={styles.black} cx="456" cy="596" r="8" />
        <circle className={styles.black} cx="484" cy="596" r="8" />
        <circle className={styles.black} cx="792" cy="596" r="8" />
        <circle className={styles.black} cx="820" cy="596" r="8" />
        <circle className={styles.black} cx="848" cy="596" r="8" />
        <circle className={styles.black} cx="876" cy="596" r="8" />
        <circle className={styles.black} cx="904" cy="596" r="8" />
        <circle className={styles.black} cx="932" cy="596" r="8" />
        <circle className={styles.black} cx="960" cy="596" r="8" />
        <circle className={styles.black} cx="988" cy="596" r="8" />
        <circle className={styles.black} cx="1016" cy="596" r="8" />
        <circle className={styles.black} cx="1044" cy="596" r="8" />
        <circle className={styles.black} cx="1072" cy="596" r="8" />
        <circle className={styles.black} cx="1100" cy="596" r="8" />
        <circle className={styles.black} cx="1128" cy="596" r="8" />
        <circle className={styles.black} cx="1156" cy="596" r="8" />
        <circle className={styles.black} cx="1184" cy="596" r="8" />
        <circle className={styles.black} cx="1268" cy="596" r="8" />
        <circle className={styles.black} cx="1296" cy="596" r="8" />
        <circle className={styles.black} cx="1324" cy="596" r="8" />
        <circle className={styles.black} cx="1352" cy="596" r="8" />
        <circle className={styles.black} cx="1408" cy="596" r="8" />
        <circle className={styles.black} cx="1436" cy="596" r="8" />
        <circle className={styles.black} cx="1464" cy="596" r="8" />
        <circle className={styles.black} cx="344" cy="624" r="8" />
        <circle className={styles.black} cx="372" cy="624" r="8" />
        <circle className={styles.black} cx="400" cy="624" r="8" />
        <circle className={styles.black} cx="428" cy="624" r="8" />
        <circle className={styles.black} cx="792" cy="624" r="8" />
        <circle className={styles.black} cx="820" cy="624" r="8" />
        <circle className={styles.black} cx="848" cy="624" r="8" />
        <circle className={styles.black} cx="876" cy="624" r="8" />
        <circle className={styles.black} cx="904" cy="624" r="8" />
        <circle className={styles.black} cx="932" cy="624" r="8" />
        <circle className={styles.black} cx="960" cy="624" r="8" />
        <circle className={styles.black} cx="988" cy="624" r="8" />
        <circle className={styles.black} cx="1016" cy="624" r="8" />
        <circle className={styles.black} cx="1044" cy="624" r="8" />
        <circle className={styles.black} cx="1072" cy="624" r="8" />
        <circle className={styles.black} cx="1100" cy="624" r="8" />
        <circle className={styles.black} cx="1128" cy="624" r="8" />
        <circle className={styles.black} cx="1156" cy="624" r="8" />
        <circle className={styles.black} cx="1296" cy="624" r="8" />
        <circle className={styles.black} cx="1324" cy="624" r="8" />
        <circle className={styles.black} cx="1408" cy="624" r="8" />
        <circle className={styles.black} cx="1436" cy="624" r="8" />
        <circle className={styles.black} cx="1464" cy="624" r="8" />
        <circle className={styles.black} cx="1548" cy="624" r="8" />
        <circle className={styles.black} cx="428" cy="652" r="8" />
        <circle className={styles.black} cx="484" cy="652" r="8" />
        <circle className={styles.black} cx="512" cy="652" r="8" />
        <circle className={styles.black} cx="540" cy="652" r="8" />
        <circle className={styles.black} cx="820" cy="652" r="8" />
        <circle className={styles.black} cx="848" cy="652" r="8" />
        <circle className={styles.black} cx="876" cy="652" r="8" />
        <circle className={styles.black} cx="904" cy="652" r="8" />
        <circle className={styles.black} cx="932" cy="652" r="8" />
        <circle className={styles.black} cx="960" cy="652" r="8" />
        <circle className={styles.black} cx="988" cy="652" r="8" />
        <circle className={styles.black} cx="1016" cy="652" r="8" />
        <circle className={styles.black} cx="1044" cy="652" r="8" />
        <circle className={styles.black} cx="1072" cy="652" r="8" />
        <circle className={styles.black} cx="1100" cy="652" r="8" />
        <circle className={styles.black} cx="1128" cy="652" r="8" />
        <circle className={styles.black} cx="1156" cy="652" r="8" />
        <circle className={styles.black} cx="1464" cy="652" r="8" />
        <circle className={styles.black} cx="1548" cy="652" r="8" />
        <circle className={styles.black} cx="484" cy="680" r="8" />
        <circle className={styles.black} cx="512" cy="680" r="8" />
        <circle className={styles.black} cx="540" cy="680" r="8" />
        <circle className={styles.black} cx="568" cy="680" r="8" />
        <circle className={styles.black} cx="596" cy="680" r="8" />
        <circle className={styles.black} cx="848" cy="680" r="8" />
        <circle className={styles.black} cx="876" cy="680" r="8" />
        <circle className={styles.black} cx="932" cy="680" r="8" />
        <circle className={styles.black} cx="960" cy="680" r="8" />
        <circle className={styles.black} cx="988" cy="680" r="8" />
        <circle className={styles.black} cx="1016" cy="680" r="8" />
        <circle className={styles.black} cx="1044" cy="680" r="8" />
        <circle className={styles.black} cx="1072" cy="680" r="8" />
        <circle className={styles.black} cx="1100" cy="680" r="8" />
        <circle className={styles.black} cx="1128" cy="680" r="8" />
        <circle className={styles.black} cx="1324" cy="680" r="8" />
        <circle className={styles.black} cx="1408" cy="680" r="8" />
        <circle className={styles.black} cx="1436" cy="680" r="8" />
        <circle className={styles.black} cx="1520" cy="680" r="8" />
        <circle className={styles.black} cx="456" cy="708" r="8" />
        <circle className={styles.black} cx="484" cy="708" r="8" />
        <circle className={styles.black} cx="512" cy="708" r="8" />
        <circle className={styles.black} cx="540" cy="708" r="8" />
        <circle className={styles.black} cx="568" cy="708" r="8" />
        <circle className={styles.black} cx="596" cy="708" r="8" />
        <circle className={styles.black} cx="960" cy="708" r="8" />
        <circle className={styles.black} cx="988" cy="708" r="8" />
        <circle className={styles.black} cx="1016" cy="708" r="8" />
        <circle className={styles.black} cx="1044" cy="708" r="8" />
        <circle className={styles.black} cx="1072" cy="708" r="8" />
        <circle className={styles.black} cx="1100" cy="708" r="8" />
        <circle className={styles.black} cx="1436" cy="708" r="8" />
        <circle className={styles.black} cx="1492" cy="708" r="8" />
        <circle className={styles.black} cx="1520" cy="708" r="8" />
        <circle className={styles.black} cx="1548" cy="708" r="8" />
        <circle className={styles.black} cx="1576" cy="708" r="8" />
        <circle className={styles.black} cx="456" cy="736" r="8" />
        <circle className={styles.black} cx="484" cy="736" r="8" />
        <circle className={styles.black} cx="512" cy="736" r="8" />
        <circle className={styles.black} cx="540" cy="736" r="8" />
        <circle className={styles.black} cx="568" cy="736" r="8" />
        <circle className={styles.black} cx="596" cy="736" r="8" />
        <circle className={styles.black} cx="624" cy="736" r="8" />
        <circle className={styles.black} cx="652" cy="736" r="8" />
        <circle className={styles.black} cx="680" cy="736" r="8" />
        <circle className={styles.black} cx="960" cy="736" r="8" />
        <circle className={styles.black} cx="988" cy="736" r="8" />
        <circle className={styles.black} cx="1016" cy="736" r="8" />
        <circle className={styles.black} cx="1044" cy="736" r="8" />
        <circle className={styles.black} cx="1072" cy="736" r="8" />
        <circle className={styles.black} cx="1100" cy="736" r="8" />
        <circle className={styles.black} cx="1436" cy="736" r="8" />
        <circle className={styles.black} cx="1548" cy="736" r="8" />
        <circle className={styles.black} cx="1632" cy="736" r="8" />
        <circle className={styles.black} cx="1660" cy="736" r="8" />
        <circle className={styles.black} cx="1688" cy="736" r="8" />
        <circle className={styles.black} cx="1716" cy="736" r="8" />
        <circle className={styles.black} cx="456" cy="764" r="8" />
        <circle className={styles.black} cx="484" cy="764" r="8" />
        <circle className={styles.black} cx="512" cy="764" r="8" />
        <circle className={styles.black} cx="540" cy="764" r="8" />
        <circle className={styles.black} cx="568" cy="764" r="8" />
        <circle className={styles.black} cx="596" cy="764" r="8" />
        <circle className={styles.black} cx="624" cy="764" r="8" />
        <circle className={styles.black} cx="652" cy="764" r="8" />
        <circle className={styles.black} cx="680" cy="764" r="8" />
        <circle className={styles.black} cx="960" cy="764" r="8" />
        <circle className={styles.black} cx="988" cy="764" r="8" />
        <circle className={styles.black} cx="1016" cy="764" r="8" />
        <circle className={styles.black} cx="1044" cy="764" r="8" />
        <circle className={styles.black} cx="1072" cy="764" r="8" />
        <circle className={styles.black} cx="1100" cy="764" r="8" />
        <circle className={styles.black} cx="1520" cy="764" r="8" />
        <circle className={styles.black} cx="1660" cy="764" r="8" />
        <circle className={styles.black} cx="1688" cy="764" r="8" />
        <circle className={styles.black} cx="484" cy="792" r="8" />
        <circle className={styles.black} cx="512" cy="792" r="8" />
        <circle className={styles.black} cx="540" cy="792" r="8" />
        <circle className={styles.black} cx="568" cy="792" r="8" />
        <circle className={styles.black} cx="596" cy="792" r="8" />
        <circle className={styles.black} cx="624" cy="792" r="8" />
        <circle className={styles.black} cx="652" cy="792" r="8" />
        <circle className={styles.black} cx="960" cy="792" r="8" />
        <circle className={styles.black} cx="988" cy="792" r="8" />
        <circle className={styles.black} cx="1016" cy="792" r="8" />
        <circle className={styles.black} cx="1044" cy="792" r="8" />
        <circle className={styles.black} cx="1072" cy="792" r="8" />
        <circle className={styles.black} cx="1100" cy="792" r="8" />
        <circle className={styles.black} cx="1156" cy="792" r="8" />
        <circle className={styles.black} cx="1576" cy="792" r="8" />
        <circle className={styles.black} cx="1604" cy="792" r="8" />
        <circle className={styles.black} cx="1660" cy="792" r="8" />
        <circle className={styles.black} cx="512" cy="820" r="8" />
        <circle className={styles.black} cx="540" cy="820" r="8" />
        <circle className={styles.black} cx="568" cy="820" r="8" />
        <circle className={styles.black} cx="596" cy="820" r="8" />
        <circle className={styles.black} cx="624" cy="820" r="8" />
        <circle className={styles.black} cx="652" cy="820" r="8" />
        <circle className={styles.black} cx="960" cy="820" r="8" />
        <circle className={styles.black} cx="988" cy="820" r="8" />
        <circle className={styles.black} cx="1016" cy="820" r="8" />
        <circle className={styles.black} cx="1044" cy="820" r="8" />
        <circle className={styles.black} cx="1072" cy="820" r="8" />
        <circle className={styles.black} cx="1128" cy="820" r="8" />
        <circle className={styles.black} cx="1548" cy="820" r="8" />
        <circle className={styles.black} cx="1576" cy="820" r="8" />
        <circle className={styles.black} cx="1604" cy="820" r="8" />
        <circle className={styles.black} cx="1632" cy="820" r="8" />
        <circle className={styles.black} cx="1660" cy="820" r="8" />
        <circle className={styles.black} cx="512" cy="848" r="8" />
        <circle className={styles.black} cx="540" cy="848" r="8" />
        <circle className={styles.black} cx="568" cy="848" r="8" />
        <circle className={styles.black} cx="596" cy="848" r="8" />
        <circle className={styles.black} cx="624" cy="848" r="8" />
        <circle className={styles.black} cx="988" cy="848" r="8" />
        <circle className={styles.black} cx="1016" cy="848" r="8" />
        <circle className={styles.black} cx="1044" cy="848" r="8" />
        <circle className={styles.black} cx="1072" cy="848" r="8" />
        <circle className={styles.black} cx="1128" cy="848" r="8" />
        <circle className={styles.black} cx="1492" cy="848" r="8" />
        <circle className={styles.black} cx="1520" cy="848" r="8" />
        <circle className={styles.black} cx="1548" cy="848" r="8" />
        <circle className={styles.black} cx="1576" cy="848" r="8" />
        <circle className={styles.black} cx="1604" cy="848" r="8" />
        <circle className={styles.black} cx="1632" cy="848" r="8" />
        <circle className={styles.black} cx="1660" cy="848" r="8" />
        <circle className={styles.black} cx="1688" cy="848" r="8" />
        <circle className={styles.black} cx="512" cy="876" r="8" />
        <circle className={styles.black} cx="540" cy="876" r="8" />
        <circle className={styles.black} cx="568" cy="876" r="8" />
        <circle className={styles.black} cx="596" cy="876" r="8" />
        <circle className={styles.black} cx="988" cy="876" r="8" />
        <circle className={styles.black} cx="1016" cy="876" r="8" />
        <circle className={styles.black} cx="1044" cy="876" r="8" />
        <circle className={styles.black} cx="1520" cy="876" r="8" />
        <circle className={styles.black} cx="1548" cy="876" r="8" />
        <circle className={styles.black} cx="1576" cy="876" r="8" />
        <circle className={styles.black} cx="1604" cy="876" r="8" />
        <circle className={styles.black} cx="1632" cy="876" r="8" />
        <circle className={styles.black} cx="1660" cy="876" r="8" />
        <circle className={styles.black} cx="1688" cy="876" r="8" />
        <circle className={styles.black} cx="1716" cy="876" r="8" />
        <circle className={styles.black} cx="512" cy="904" r="8" />
        <circle className={styles.black} cx="540" cy="904" r="8" />
        <circle className={styles.black} cx="568" cy="904" r="8" />
        <circle className={styles.black} cx="596" cy="904" r="8" />
        <circle className={styles.black} cx="988" cy="904" r="8" />
        <circle className={styles.black} cx="1016" cy="904" r="8" />
        <circle className={styles.black} cx="1520" cy="904" r="8" />
        <circle className={styles.black} cx="1548" cy="904" r="8" />
        <circle className={styles.black} cx="1632" cy="904" r="8" />
        <circle className={styles.black} cx="1660" cy="904" r="8" />
        <circle className={styles.black} cx="1688" cy="904" r="8" />
        <circle className={styles.black} cx="484" cy="932" r="8" />
        <circle className={styles.black} cx="512" cy="932" r="8" />
        <circle className={styles.black} cx="540" cy="932" r="8" />
        <circle className={styles.black} cx="568" cy="932" r="8" />
        <circle className={styles.black} cx="1660" cy="932" r="8" />
        <circle className={styles.black} cx="1688" cy="932" r="8" />
        <circle className={styles.black} cx="484" cy="960" r="8" />
        <circle className={styles.black} cx="512" cy="960" r="8" />
        <circle className={styles.black} cx="1688" cy="960" r="8" />
        <circle className={styles.black} cx="1828" cy="960" r="8" />
        <circle className={styles.black} cx="484" cy="988" r="8" />
        <circle className={styles.black} cx="512" cy="988" r="8" />
        <circle className={styles.black} cx="1800" cy="988" r="8" />
        <circle className={styles.black} cx="484" cy="1016" r="8" />
        <circle className={styles.black} cx="512" cy="1016" r="8" />
        <circle className={styles.black} cx="484" cy="1044" r="8" />
        <circle className={styles.black} cx="512" cy="1044" r="8" />
      </g>
      <g ref={greenDots}>
        {/* <circle className={styles.green} cx="988" cy="288" r="8" />
        <circle className={styles.green} cx="876" cy="372" r="8" />
        <circle className={styles.green} cx="876" cy="400" r="8" />
        <circle className={styles.green} cx="904" cy="400" r="8" />
        <circle className={styles.green} cx="932" cy="400" r="8" />
        <circle className={styles.green} cx="428" cy="428" r="8" />
        <circle className={styles.green} cx="988" cy="428" r="8" />
        <circle className={styles.green} cx="484" cy="456" r="8" />
        <circle className={styles.green} cx="904" cy="456" r="8" />
        <circle className={styles.green} cx="456" cy="484" r="8" />
        <circle className={styles.green} cx="876" cy="484" r="8" />
        <circle className={styles.green} cx="1212" cy="512" r="8" />
        <circle className={styles.green} cx="1184" cy="540" r="8" />
        <circle className={styles.green} cx="1492" cy="568" r="8" /> */}
        <g className={styles.hoverGroup}>
          <circle className={styles.green} cx="988" cy="288" r="8" />
          <rect
            className={styles.labelBackground}
            x="948"
            y="245"
            width="80"
            height="24"
            rx="4"
          />
          <text className={styles.cityLabel} x="988" y="263">
            Stockholm
          </text>
        </g>
        <g className={styles.hoverGroup}>
          <circle className={styles.green} cx="876" cy="372" r="8" />
          <rect
            className={styles.labelBackground}
            x="836"
            y="329"
            width="80"
            height="24"
            rx="4"
          />
          <text className={styles.cityLabel} x="876" y="347">
            London
          </text>
        </g>
        <g className={styles.hoverGroup}>
          <circle className={styles.green} cx="876" cy="400" r="8" />
          <rect
            className={styles.labelBackground}
            x="836"
            y="357"
            width="80"
            height="24"
            rx="4"
          />
          <text className={styles.cityLabel} x="876" y="375">
            Paris
          </text>
        </g>
        <g className={styles.hoverGroup}>
          <circle className={styles.green} cx="904" cy="400" r="8" />
          <rect
            className={styles.labelBackground}
            x="864"
            y="357"
            width="80"
            height="24"
            rx="4"
          />
          <text className={styles.cityLabel} x="904" y="375">
            Amsterdam
          </text>
        </g>
        <g className={styles.hoverGroup}>
          <circle className={styles.green} cx="932" cy="400" r="8" />
          <rect
            className={styles.labelBackground}
            x="892"
            y="357"
            width="80"
            height="24"
            rx="4"
          />
          <text className={styles.cityLabel} x="932" y="375">
            Frankfurt
          </text>
        </g>
        <g className={styles.hoverGroup}>
          <circle className={styles.green} cx="428" cy="428" r="8" />
          <rect
            className={styles.labelBackground}
            x="388"
            y="385"
            width="80"
            height="24"
            rx="4"
          />
          <text className={styles.cityLabel} x="428" y="403">
            Toronto
          </text>
        </g>
        <g className={styles.hoverGroup}>
          <circle className={styles.green} cx="988" cy="428" r="8" />
          <rect
            className={styles.labelBackground}
            x="948"
            y="385"
            width="80"
            height="24"
            rx="4"
          />
          <text className={styles.cityLabel} x="988" y="403">
            Warsaw
          </text>
        </g>
        <g className={styles.hoverGroup}>
          <circle className={styles.green} cx="484" cy="456" r="8" />
          <rect
            className={styles.labelBackground}
            x="444"
            y="413"
            width="80"
            height="24"
            rx="4"
          />
          <text className={styles.cityLabel} x="484" y="431">
            New York
          </text>
        </g>
        <g className={styles.hoverGroup}>
          <circle className={styles.green} cx="904" cy="456" r="8" />
          <rect
            className={styles.labelBackground}
            x="864"
            y="413"
            width="80"
            height="24"
            rx="4"
          />
          <text className={styles.cityLabel} x="904" y="431">
            Milan
          </text>
        </g>
        <g className={styles.hoverGroup}>
          <circle className={styles.green} cx="456" cy="484" r="8" />
          <rect
            className={styles.labelBackground}
            x="416"
            y="441"
            width="80"
            height="24"
            rx="4"
          />
          <text className={styles.cityLabel} x="456" y="459">
            Philadelphia
          </text>
        </g>
        <g className={styles.hoverGroup}>
          <circle className={styles.green} cx="876" cy="484" r="8" />
          <rect
            className={styles.labelBackground}
            x="836"
            y="441"
            width="80"
            height="24"
            rx="4"
          />
          <text className={styles.cityLabel} x="876" y="459">
            Madrid
          </text>
        </g>
        <g className={styles.hoverGroup}>
          <circle className={styles.green} cx="1212" cy="512" r="8" />
          <rect
            className={styles.labelBackground}
            x="1172"
            y="469"
            width="80"
            height="24"
            rx="4"
          />
          <text className={styles.cityLabel} x="1212" y="487">
            Dubai
          </text>
        </g>
        <g className={styles.hoverGroup}>
          <circle className={styles.green} cx="1184" cy="540" r="8" />
          <rect
            className={styles.labelBackground}
            x="1144"
            y="497"
            width="80"
            height="24"
            rx="4"
          />
          <text className={styles.cityLabel} x="1184" y="515">
            Riyadh
          </text>
        </g>
        <g className={styles.hoverGroup}>
          <circle className={styles.green} cx="1492" cy="568" r="8" />
          <rect
            className={styles.labelBackground}
            x="1452"
            y="525"
            width="80"
            height="24"
            rx="4"
          />
          <text className={styles.cityLabel} x="1492" y="543">
            Hong Kong
          </text>
        </g>
      </g>
    </svg>
  );
};

export default AnimatedMap;
